import { render, staticRenderFns } from "./ReportTwoday.vue?vue&type=template&id=2a4643dd&scoped=true&"
import script from "./ReportTwoday.vue?vue&type=script&lang=js&"
export * from "./ReportTwoday.vue?vue&type=script&lang=js&"
import style0 from "./ReportTwoday.vue?vue&type=style&index=0&id=2a4643dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4643dd",
  null
  
)

export default component.exports